import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ApplyDateState } from "@tKgpco/Store/Data/Cart/ApplyDateToAllLinesState";
import { Draft } from "immer";

const initialState: ApplyDateState = {
    applyDateToAllLines: false,
};

export const reducer = {
    "Custom/Cart/ApplyDateToAllLines": (draft: Draft<ApplyDateState>, action: { param: boolean }) => {
        draft.applyDateToAllLines = action.param;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
